import { useEffect, useState } from 'react';
import {
  Container,
  Label,
  Select,
  Option
} from '../../add/spacer/spacer-add-section.styles';

const heightOptions = [
  { value: '1rem', label: 'Small (1rem)' },
  { value: '2rem', label: 'Medium (2rem)' },
  { value: '4rem', label: 'Large (4rem)' },
  { value: '8rem', label: 'Extra Large (8rem)' }
];

const SpacerUpdateSection = ({ content = {}, metadata = {}, onChange }) => {
  const [height, setHeight] = useState(metadata?.height || '2rem');

  useEffect(() => {
    onChange({ content: {}, metadata: { height } });
  }, [height]);

  return (
    <Container>
      <Label htmlFor="spacer-height">Select Spacer Height</Label>
      <Select
        id="spacer-height"
        value={height}
        onChange={(e) => setHeight(e.target.value)}
      >
        {heightOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Container>
  );
};

export default SpacerUpdateSection;